module.exports = __webpack_public_path__ + "img/3.d2d29219.jpg";